 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {useAutocomplete} from '@mui/base/AutocompleteUnstyled'
import CheckIcon from '@mui/icons-material/Check'


import {Send as SendIcon} from '@mui/icons-material'
import {Chip} from '../../ui/Chip/Chip'
import {emailRegex} from '../../validation/regex'

 














const autocompleteEmail = (input, domain) => {
  // If the input already ends with the provided domain, or is just "@" then return it as-is.
  if (input.endsWith(`@${domain}`) || input === '@') {
    return input
  }

  // Split the input by "@" to separate the username and domain parts.
  const [username, potentialDomain] = input.split('@')

  // If there's a domain part and it's not empty, return the input as-is.
  if (potentialDomain && potentialDomain.length > 0) {
    return input
  }

  // If the input doesn't have a domain part, append the provided domain.
  return `${username}@${domain}`
}

export const AdhocTeamMultiSelect = (props) => {
  const {viewerRef, onChange, value, multiple = true} = props
  const [error, setError] = React.useState(null)

  const viewer = useFragment(
    graphql`
      fragment AdhocTeamMultiSelect_viewer on User {
        id
        email
        organizations {
          id
          organizationUsers {
            edges {
              node {
                user {
                  id
                  preferredName
                  picture
                  email
                }
              }
            }
          }
        }
      }
    `,
    viewerRef
  )

  const {email, organizations} = viewer
  const viewerDomain = email.slice(email.indexOf('@') + 1)

  const usersMap = {}

  organizations.forEach((org) => {
    org.organizationUsers.edges.forEach((edge) => {
      const user = edge.node.user
      if (user.id === viewer.id) {
        return
      }
      if (!usersMap[user.id]) {
        usersMap[user.id] = {
          id: user.id,
          label: user.preferredName,
          email: user.email,
          picture: user.picture,
          organizationIds: [org.id]
        }
      } else {
        _optionalChain([usersMap, 'access', _2 => _2[user.id], 'optionalAccess', _3 => _3.organizationIds, 'access', _4 => _4.push, 'call', _5 => _5(org.id)])
      }
    })
  })

  const options = Object.values(usersMap)

  const createCustomOption = (option) => {
    return {
      label: `Invite ${option}`,
      email: option,
      organizationIds: [],
      picture: null,
      id: null
    }
  }

  const {
    getRootProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    setAnchorEl
  } = useAutocomplete({
    multiple: true,
    autoSelect: true,
    options,
    value,
    freeSolo: true,
    isOptionEqualToValue: (option, value) => {
      return !!(option.id && value.id && option.id === value.id)
    },
    onChange: (_, newValue) => {
      // We manually handle multiple = false, as we want chips and multiple behaviour but just limit items to 1
      const valueArray = multiple ? newValue : newValue[0] ? [_nullishCoalesce(newValue[1], () => ( newValue[0]))] : []

      const normalizedNewValue = valueArray.map((value) =>
        typeof value === 'string' ? createCustomOption(value) : value
      )

      const isValid =
        !normalizedNewValue.length ||
        normalizedNewValue.some((value) => emailRegex.test(value.email))
      if (!isValid) {
        setError('Please enter a valid email')
        return
      }

      setError(null)
      onChange(normalizedNewValue)
    },
    filterOptions: (options, params) => {
      const filtered = options.filter((option) => {
        const label = typeof option === 'string' ? option : option.label
        return label.toLowerCase().includes(params.inputValue.toLowerCase())
      })

      const autocompletedEmail = autocompleteEmail(params.inputValue, viewerDomain)
      const suggestedInvitationOption = createCustomOption(autocompletedEmail)

      if (params.inputValue) {
        filtered.unshift(suggestedInvitationOption)
      }

      return filtered
    }
  })

  return (
    React.createElement('div', null
      , React.createElement('div', { ...getRootProps(),}
        , React.createElement('div', {
          ref: setAnchorEl,
          className: "align-center flex min-h-[44px] w-full flex-wrap rounded border border-slate-500 bg-white px-1 py-0.5 text-sm"           ,}

          , value.map((option, index) => (
            React.createElement(Chip, {
              label: option.label,
              picture: option.picture,
              icon: !option.id ? React.createElement(SendIcon, { className: "text-base",} ) : null,
              ...getTagProps({index}),
              key: _nullishCoalesce(option.id, () => ( option.email)),
              className: "m-0.5",}
            )
          ))
          , React.createElement('input', {
            ...getInputProps(),
            placeholder: !value.length ? 'ex. Traci or traci@example.com' : '',
            className: "m-0 box-border min-h-[36px] w-0 min-w-[30px] flex-grow border-0 bg-white pl-1 text-black outline-none"          ,}
          )
        )
        , error && React.createElement('div', { className: "mt-2 text-sm font-semibold text-tomato-500"   ,}, error)
      )
      , groupedOptions.length > 0 ? (
        React.createElement('ul', {
          ...getListboxProps(),
          className: "absolute z-50 mt-0.5 h-auto max-h-64 w-[300px] list-none overflow-y-auto rounded bg-white p-0 shadow-card-1"           ,}

          , (groupedOptions ).map((option, index) => {
            const optionProps = getOptionProps({option, index})
            const isSelected = optionProps['aria-selected']
            return (
              React.createElement('li', {
                ...optionProps,
                key: _nullishCoalesce(option.id, () => ( option.email)),
                className: `[&.Mui-focused]:bg-slate-100 ${
                  isSelected ? 'bg-slate-100' : ''
                } flex h-10 w-full cursor-pointer select-none items-center justify-between rounded px-3 text-sm outline-none hover:bg-slate-100 focus:bg-slate-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50`,}

                , !option.id && React.createElement(SendIcon, { className: "mr-2 text-base" ,} )
                , option.id && (
                  React.createElement('div', { className: "relative mr-2 h-6 w-6 rounded border border-slate-100"      ,}
                    , React.createElement('div', {
                      className: "h-6 w-6 rounded-full bg-cover bg-center bg-no-repeat"     ,
                      style: {backgroundImage: `url('${option.picture}')`},}
                    )
                  )
                )
                , React.createElement('span', { className: 'flex-grow',}, option.label)

                , isSelected && React.createElement(CheckIcon, { className: "h-5 w-5" ,} )
              )
            )
          })
        )
      ) : null
    )
  )
}
